import { observer } from 'mobx-react';
import GroupStore from '../../../GroupStore';
import GroupsStore from '../../../GroupsStore';
import {
  GroupResource,
  Ready,
  Sorting,
  UpdatingQuery,
  UpdatingSearchParameters,
} from '../../../GroupsStore/Types';
import { MulticheckStore } from '../../../Multicheck/Store';
import ModalStore from '../../Modal/Store';
import BulkActions from './BulkActions';
import Filters from './Filters';
import LoadMoreIf from './LoadMoreIf';
import TableOrEmpty from './TableOrEmpty';
import Table from '../Participants/Skeleton/Table';

interface Props {
  store: GroupsStore;
  groupStore: GroupStore;
  modalStore: ModalStore;
  multicheckStore: MulticheckStore<GroupResource>;
  groupsStoreState: Ready | UpdatingQuery | UpdatingSearchParameters | Sorting;
}

function GroupsView({ store, modalStore, groupStore, multicheckStore, groupsStoreState }: Props) {
  switch (groupsStoreState.kind) {
    case 'ready':
      const { groupsResource } = groupsStoreState;
      const { payload } = groupsResource;
      const { metadata } = groupsResource;
      return (
        <div className="px-2.5 lg:px-12">
          <Filters store={store} groupsStoreState={groupsStoreState} />
          <TableOrEmpty
            store={store}
            groupStore={groupStore}
            modalStore={modalStore}
            multicheckStore={multicheckStore}
            groupsResource={payload}
          />
          <LoadMoreIf store={store} metadata={metadata} displayedCount={payload.length} />
          <BulkActions multicheckStore={multicheckStore} links={groupsResource.links} />
        </div>
      );
    case 'sorting':
    case 'updating-query':
    case 'updating-search-parameters':
      return (
        <div className="px-2.5 lg:px-12">
          <Filters store={store} groupsStoreState={groupsStoreState} />
          <Table tableColCount={7} checkBoxRequirement="not-required" tableRowCount={15} />
        </div>
      );
  }
}

export default observer(GroupsView);
